import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "icon-fill-secondary",
		d: "M37 20.3v-2.5h-6v-4.1h3.2v-2.5H10.7v2.5H14v4.1H8.6v2.5H14v4.4H8.6v2.5H14v4.2h-3.4v2.5h23.6v-2.5H31v-4.2h6v-2.5h-6v-4.4h6zm-8.5-2.5h-4.7v-4.1h4.7v4.1zm-12-4.1h4.7v4.1h-4.7v-4.1zm0 6.6h4.7v4.4h-4.7v-4.4zm0 6.9h4.7v4.2h-4.7v-4.2zm12 4.1h-4.7v-4.2h4.7v4.2zm0-6.6h-4.7v-4.4h4.7v4.4z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M43.7 9.2c-.7 0-1.2.6-1.2 1.2v.7h-8.1C31.4 8 27.2 6 22.5 6s-8.9 2-11.9 5.1H2.5v-.7c0-.7-.6-1.2-1.2-1.2S0 9.8 0 10.5v24c0 .7.6 1.2 1.2 1.2s1.2-.6 1.2-1.2v-.7h8.1c3 3.1 7.2 5.1 11.9 5.1s8.9-2 11.9-5.1h8.1v.7c0 .7.6 1.2 1.2 1.2s1.2-.6 1.2-1.2v-24c.2-.7-.4-1.3-1.1-1.3zM2.5 31.3V13.7h6.2c-1.6 2.6-2.6 5.6-2.6 8.8 0 3.3 1 6.3 2.6 8.8H2.5zm20 5.1c-7.7 0-13.9-6.2-13.9-13.9S14.8 8.6 22.5 8.6s13.9 6.2 13.9 13.9-6.2 13.9-13.9 13.9zm13.8-5.1c1.6-2.6 2.6-5.6 2.6-8.8 0-3.3-1-6.3-2.6-8.8h6.1v17.7h-6.1z"
	})]
});
export default SvgIcon;
